module.exports = __webpack_public_path__ + "img/kml.ff5af8be.svg";